
import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Box, Button, FormField, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiFilterMenuOutline, mdiFilterMultiple, mdiHumanMaleBoard, mdiMagnify, mdiTowTruck } from '@mdi/js';
import Icon from '@mdi/react';
import DRPicker from '../../../../../components/DRPicker';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import SelectCategory from '../../../../../components/selects/selectCategory';
import SelectEquipment from '../../../../../components/selects/selectEquipment';
import SelectFlightType from '../../../../../components/selects/selectFlightTypes';
import SelectGroupType from '../../../../../components/selects/selectGroupType';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemEquipment, ItemFlight } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, minutes2Hours, minutesToHHMM2, setData, setLoading, setParameters } from '../../../../commons/functions';

export const MasterEquipmentsSyncSMPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [stage, setStage] = useState("A")


    const { navigate } = useRouter();
    const { data, parameters, menu } = useGlobalState();
    const [flights, setFlights] = useState<ItemFlight[]>([]);
    const [flight, setFlight] = useState<ItemFlight>();
    const [userCount, setUserCount] = useState<number>(0);
    const [advanceFilter, setAdvanceFilter] = useState<boolean>(false);


    useEffect(() => {
        if (parameters.startDate && parameters.endDate && parameters.pilotType && parameters.groupTypeMasterCode) {
            //handleFlightsSearch()
        }
    }, [parameters.startDate, parameters.endDate, parameters.pilotType, parameters.groupTypeMasterCode, parameters.idCategories, parameters.idGroupTypes, parameters.idFlightTypes, parameters.idUser]);

    const handleSyncFlight = async (id: number) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/flights/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idFlight: id }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                handleFlightsSearch()
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleFlightsSearch = async () => {
        try {
            setLoading(true)
            let body: any = {
                startDate: parameters.startDate,
                endDate: parameters.endDate,
                pilotType: parameters.pilotType ? parameters.pilotType : '',
                orderBy: "departureDate",
                order: "desc",
            }
            if (parameters.groupTypeMasterCode && parameters.groupTypeMasterCode.value != '') {
                //body = { ...body, groupTypeMasterCode: parameters.groupTypeMasterCode.value }
            }
            if (parameters.idEquipment && parameters.idEquipment > 0) {
                body = { ...body, idEquipment: parameters.idEquipment }
            }
            if (parameters.idCategories && parameters.idCategories.length > 0) {
                body = { ...body, idCategories: parameters.idCategories }
            }
            if (parameters.idGroupTypes && parameters.idGroupTypes.length > 0) {
                body = { ...body, idGroupTypes: parameters.idGroupTypes }
            }
            if (parameters.idFlightTypes && parameters.idFlightTypes.length > 0) {
                body = { ...body, idFlightTypes: parameters.idFlightTypes }
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setFlights(data.flights);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const totalFilters = parameters.idCategories?.length + parameters.idGroupTypes?.length + parameters.idFlightTypes?.length;

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Bitácora de vuelos</Header>
                    <Table
                        filter={
                            <SpaceBetween direction="horizontal" size="xs">
                                <Box textAlign='left'>
                                    <SpaceBetween direction="vertical" size="xs">
                                        <SpaceBetween direction="horizontal" size="xs">
                                            <FormField label="Material">
                                                <SelectEquipment


                                                    onConfirm={(equipment: ItemEquipment | undefined) => {
                                                        if (equipment)
                                                            setParameters({ ...parameters, idEquipment: equipment.idEquipment });
                                                        else
                                                            setParameters({ ...parameters, idEquipment: 0 });
                                                    }}
                                                    value={parameters.idEquipment}
                                                />
                                            </FormField>

                                            <FormField label="Rango de fechas">
                                                <DRPicker
                                                    start={parameters.startDate || ''}
                                                    end={parameters.endDate || ''}

                                                    onConfirm={(start: string, end: string) => {
                                                        setParameters({ ...parameters, startDate: start, endDate: end });

                                                    }}
                                                />
                                            </FormField>
                                            <FormField label="&nbsp;">
                                                <Button style={{ root: btnIconForm }} onClick={() => setAdvanceFilter(!advanceFilter)}>
                                                    <SpaceBetween direction="horizontal" size="xs">
                                                        {advanceFilter ? <Icon path={mdiFilterMultiple} size={1} /> : <Icon path={mdiFilterMenuOutline} size={1} />}
                                                        {totalFilters > 0 ? totalFilters : null}
                                                    </SpaceBetween>
                                                </Button>
                                            </FormField>
                                            <FormField label="&nbsp;">
                                                <Button style={{ root: btnIconForm }} disabled={!parameters.idEquipment || parameters.idEquipment === 0} onClick={() => {
                                                    if (window.location.hash.includes("?id=")) {
                                                        window.location.hash = "cma/equipments/logs";
                                                    }
                                                    handleFlightsSearch()
                                                }}><Icon path={mdiMagnify} size={1} /></Button>
                                            </FormField>

                                        </SpaceBetween>
                                        {advanceFilter && (
                                            <SpaceBetween direction="vertical" size="xs">
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    <FormField label="Categoría">
                                                        <SelectCategory single={false} onSelect={(idCategories) => {
                                                            setParameters({ ...parameters, idCategories: idCategories });
                                                        }} value={parameters.idCategories} hideTokens={false} tokenLimit={0}
                                                        />
                                                    </FormField>

                                                    <FormField label="Grupo">
                                                        <SelectGroupType single={false} onSelect={(idGroupTypes) => {
                                                            setParameters({ ...parameters, idGroupTypes: idGroupTypes });
                                                        }} value={parameters.idGroupTypes} hideTokens={false} tokenLimit={0}
                                                        />
                                                    </FormField>
                                                    <FormField label="Tipo de vuelo">
                                                        <SelectFlightType single={false} onSelect={(idFlightTypes) => {
                                                            setParameters({ ...parameters, idFlightTypes: idFlightTypes });
                                                        }} value={parameters.idFlightTypes} hideTokens={false} tokenLimit={0}

                                                        />
                                                    </FormField>
                                                </SpaceBetween>
                                            </SpaceBetween>
                                        )}
                                    </SpaceBetween>
                                </Box>
                            </SpaceBetween >
                        }
                        items={flights}
                        stickyHeader
                        cellVerticalAlign='top'
                        variant='embedded'
                        empty={
                            < Box textAlign="center" color="inherit" >
                                <b>No hay vuelos que mostrar</b>
                                <Box padding={{ top: 's' }} variant="p" color="inherit">
                                    Ajusta los filtros para ver los vuelos registrados.
                                </Box>
                            </Box >
                        }
                        footer=
                        {
                            flights.length > 0 && (<SpaceBetween direction="horizontal" size="xs">
                                <div>
                                    Número de vuelos: <strong>{flights.length}</strong>
                                </div>
                                <div>
                                    Tiempo total: <strong>{flights.reduce((acc, flight) => acc + flight.delta, 0) ? minutesToHHMM2(flights.reduce((acc, flight) => acc + flight.delta, 0)) : '00:00'}</strong>
                                </div>
                            </SpaceBetween>)
                        }
                        columnDefinitions={
                            [
                                {
                                    id: 'id',
                                    header: 'ID/Fecha',
                                    cell: (item) => <FormField label={item.idFlight}
                                        constraintText={item.departureDate}
                                    >


                                        {item?.jsonSoftMantto?.id && (
                                            <BadgeCustom color='blue' size="small">{item.jsonSoftMantto.id}</BadgeCustom>
                                        )}
                                    </FormField>,
                                    maxWidth: 100,
                                },
                                {
                                    id: 'aircraft',
                                    header: 'Material',
                                    cell: (item) => (
                                        // 🔑 FIX 2: Add key to the outermost component in the cell
                                        <FormField key={`aircraft-formfield-${item.idFlight}`} label={item.registration}>
                                            {item.groupTypeMaster} {item.idTowingTo > 0 ? <Icon path={mdiTowTruck} size={1} /> : ''}
                                        </FormField>
                                    ),
                                    maxWidth: 80,
                                },
                                {
                                    id: 'departure',
                                    header: 'Tripulación',
                                    cell: (item) => (
                                        <FormField label={item.userPilot} key={`labelinstructor-${item.idFlight}`}>
                                            {item.idUserInstructor > 0 ? (
                                                <SpaceBetween direction="horizontal" size="xs" key={`instructor-spacebetween-${item.idFlight}`}>
                                                    {/* 🔑 FIX 1: Add keys to the children of SpaceBetween */}
                                                    <Icon path={mdiHumanMaleBoard} size={1} key={`icon-${item.idFlight}`} />
                                                    <span key={`instructor-name-${item.idFlight}`}>{item.userInstructor}</span>
                                                </SpaceBetween>
                                            ) : (
                                                // Always return a valid React element or null/'' if conditionally rendering
                                                ''
                                            )}
                                        </FormField>
                                    ),
                                },
                                {
                                    id: 'flightType',
                                    header: 'Tipo',
                                    cell: (item) => item.flightType,
                                    maxWidth: 100
                                },
                                {
                                    id: 'duration',
                                    header: 'TPO',
                                    cell: (item) => <FormField label={minutesToHHMM2(item.delta ?? 0)} description={`${minutes2Hours(item.delta)} h`} />,
                                    width: 80,
                                },
                                {
                                    id: 'sync',
                                    header: '',
                                    cell: (item) => <Button onClick={() => {
                                        handleSyncFlight(item.idFlight)
                                    }}>{!item.jsonSoftMantto.id ? "Enviar" : "Actualizar"}</Button>

                                    ,
                                    maxWidth: 160,
                                },
                            ]}

                    />

                </SpaceBetween >
            }
        />
    )
};

